import { useQuery } from "@tanstack/react-query";
import { EmissioneventsListDataSourceEnum } from "../../../../../apiClient/generated";
import { useEmissionRecordsApiClient } from "../../../../../hooks";
import { ROUTES } from "../../../../../routes";
import { DataPointHistoryDisplay } from "../../../../Emissions/DataPointHistoryDisplay";
import { EmissionRecordDisplay } from "../../../../Emissions/EmissionRecordDisplay";
import { useMapData } from "../../../hooks/mapDataAndFilters";
import { SidebarSection } from "../../../ui/SidebarItems";
import { EventSidebarDisplay, SiteSidebarDisplay } from "./common";

export const EmissionDetailsTab = () => {
    const { selectedContext } = useMapData("mainMap");
    const emissionsApiClient = useEmissionRecordsApiClient();

    // Emission information
    const emissionQuery = useQuery({
        queryKey: ["emissionRecord", selectedContext.emissionRecordId],
        queryFn: async () => {
            return await emissionsApiClient.emissionRecordsRetrieve({
                id: selectedContext.emissionRecordId,
            });
        },
        enabled: !!selectedContext.emissionRecordId,
    });

    const infrastructureAction = {
        label: "Site",
        fn: () => {
            // Compute time ranges within 3 months of the emission
            let beforeDate: Date;
            let afterDate: Date;
            if (emissionQuery.data) {
                const timestamp =
                    emissionQuery.data?.dataPoint.detectionTimestamp.getTime();
                beforeDate = new Date(timestamp + 45 * 24 * 60 * 60 * 1000);
                afterDate = new Date(timestamp - 45 * 24 * 60 * 60 * 1000);
            }

            const url = `${ROUTES.INFRASTRUCTURE_SITE}?site=${emissionQuery.data?.site.id}&selectedContext=${emissionQuery.data?.id}&detectionDateRangeAfter=${afterDate.toISOString()}&detectionDateRangeBefore=${beforeDate.toISOString()}`;

            window.open(url);
        },
    };

    return (
        <div className="w-[400px] h-full bg-white">
            <SidebarSection
                title="Properties"
                loading={emissionQuery.isLoading}
                action={{
                    label: "Manage Emission",
                    fn: () => {
                        let basePage = "";
                        let id = emissionQuery.data?.id;
                        if (
                            emissionQuery.data?.dataPoint.dataSource ===
                            EmissioneventsListDataSourceEnum.ThirdParty
                        ) {
                            basePage = ROUTES.DASHBOARD_THIRD_PARTY;
                        } else if (
                            emissionQuery.data?.dataPoint.dataSource ===
                            EmissioneventsListDataSourceEnum.SelfReported
                        ) {
                            basePage = ROUTES.DASHBOARD_SELF_REPORTED;
                        } else if (
                            emissionQuery.data?.dataPoint.dataSource ===
                            EmissioneventsListDataSourceEnum.Epa
                        ) {
                            id = emissionQuery.data?.epaoperatornotification;
                            basePage = ROUTES.DASHBOARD_EPA_SEP;
                        }
                        window.open(
                            `${basePage}?selectedEvent=${id}`,
                            "_blank",
                        );
                    },
                }}
            >
                <EmissionRecordDisplay emissionRecord={emissionQuery.data} />
            </SidebarSection>
            {emissionQuery.data && emissionQuery.data.mainEvent && (
                <SidebarSection
                    title="Event Management"
                    loading={emissionQuery.isLoading}
                >
                    <EventSidebarDisplay event={emissionQuery.data.mainEvent} />
                </SidebarSection>
            )}
            {emissionQuery.data && emissionQuery.data.site && (
                <SidebarSection
                    title="Infrastructure"
                    loading={emissionQuery.isLoading}
                    action={infrastructureAction}
                >
                    <SiteSidebarDisplay site={emissionQuery.data.site} />
                </SidebarSection>
            )}
            {emissionQuery.data &&
                !!emissionQuery.data.dataPoint?.history.length && (
                    <SidebarSection
                        title="History"
                        loading={emissionQuery.isLoading}
                    >
                        <DataPointHistoryDisplay
                            history={emissionQuery.data.dataPoint.history}
                        />
                    </SidebarSection>
                )}
        </div>
    );
};
